import React, { useEffect, useRef } from "react";
import S from "./ChannelList.styled";
import ChannelItem from "./ChannelItem";
import { ChannelProvider } from "../../hooks";
import useKeyPress from "../../hooks/useKeyPress";
import useCursor from "../../hooks/useCursor";
export default function ChannelListSection({ header, channels, selectedChannel, handleSelect, }) {
    const channelListRef = useRef(null);
    const downPress = useKeyPress("ArrowDown", channelListRef);
    const upPress = useKeyPress("ArrowUp", channelListRef);
    const cursor = useCursor(channels.length, downPress, upPress);
    useEffect(() => {
        var _a, _b;
        const channelsNode = (_a = channelListRef.current) === null || _a === void 0 ? void 0 : _a.querySelectorAll("button");
        (_b = channelsNode === null || channelsNode === void 0 ? void 0 : channelsNode[cursor]) === null || _b === void 0 ? void 0 : _b.focus();
    }, [cursor]);
    if (channels.length === 0)
        return null;
    return (React.createElement(React.Fragment, null,
        React.createElement(S.DirectMessageWrapper, null,
            React.createElement(S.DirectMessageTitle, null, header)),
        React.createElement(S.ChannelsListWrapper, { ref: channelListRef }, channels.map((ch) => (React.createElement(ChannelProvider, { channel: ch, key: ch.id },
            React.createElement(ChannelItem, { onClick: () => handleSelect(ch), isSelected: ch.id === (selectedChannel === null || selectedChannel === void 0 ? void 0 : selectedChannel.id) })))))));
}
//# sourceMappingURL=ChannelListSection.js.map